import { useState, useEffect } from "react";
import "react-toastify/dist/ReactToastify.css";
// import { getBookCitationInfo, getPodcastCitationInfo, getSeedFileInfo } from "../../../api";
import Drawer from "react-modern-drawer";
import "react-modern-drawer/dist/index.css";
import PodcastViewer from "../podcast/PodcastViewer";
import PodcastViewerInDrawer from "./citationTypes/PodcastViewerInDrawer";
import { getBookCitationInfo, getPodcastCitationInfo, getSeedFileInfo } from "../../api";
import ExclusiveContentViewer from "./citationTypes/ExclusiveContentViewer";
import BookViewerInDrawer from "./citationTypes/BookViewerInDrawer";

interface podcastType {
    citation: string;
    link: string;
    media_type: string;
    title: string;
}
interface bookType {
    citation: string;
    media_type: string;
    book_name: string;
    chapter: string;
    // chapter:string;
}
const ShowCitationExplorerSource = ({ open, onClose, citation }: any) => {
    const [seedFileData, setSeedFileData] = useState<any>();
    const [isLoading, setIsLoading] = useState(false);
    const [podcastText, setPodcastText] = useState<string>();
    const [pdfBookImages, setPdfBookImages] = useState<string[]>();
    const [bookLink, setBookLink] = useState<string>();

    const [error, setError] = useState<string | null>(null);
    const [podcastError, setPodcastError] = useState<string | null>(null);
    const [bookError, setBookError] = useState<string | null>(null);

    const screenWidth = window.innerWidth;
    let size = window.innerWidth * 0.7;
    if (screenWidth < 640) {
        size = window.innerWidth;
    }

    function formatDate(dateString: string) {
        if (!dateString) return null;

        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;

        return date.toISOString().split("T")[0];
    }
    async function fetchSeedsInfo(seedFileName: string) {
        setIsLoading(true);
        try {
            const path = seedFileName.split("/");
            const seedFileData = await getSeedFileInfo(path[path.length - 1]);
            const seedData = await seedFileData.data;
            setSeedFileData(seedData);
        } catch (error: any) {
            console.error(`Failed to fetch source info `, error);
            setError(error.message); // Set error message when request fails
        } finally {
            setIsLoading(false);
        }
    }
    function decodeUnicode(input: string): string {
        return input.replace(/\\u[\dA-Fa-f]{4}/g, match => String.fromCharCode(parseInt(match.replace("\\u", ""), 16)));
    }
    async function fetchPodcastInfo(citation: podcastType) {
        setIsLoading(true);
        if (citation) {
            try {
                const podcastJsonData = await getPodcastCitationInfo(citation.citation);
                const podcastData = await podcastJsonData.data;
                if (podcastData.status === "success" && podcastData?.podcast_info) {
                    const cleanedText = podcastData?.podcast_info.podcast_summary.replace(/\\n/g, "\n");

                    setPodcastText(decodeUnicode(cleanedText));
                } else if (podcastData.status === "error") {
                    setPodcastError(podcastData?.message);
                }
            } catch (error: any) {
                console.error(`Failed to fetch source info `, error);
                setPodcastError(error.message); // Set error message when request fails
            } finally {
                setIsLoading(false);
            }
        }
    }
    async function fetchBookInfo(citation: bookType) {
        setIsLoading(true);
        if (citation) {
            try {
                const pdfFileData = await getBookCitationInfo(citation.book_name, citation.chapter);
                const pdfData = await pdfFileData.data;
                if (pdfData.status === "success" && pdfData?.page_images) {
                    setPdfBookImages(pdfData.page_images);
                    setBookLink(pdfData.link);
                } else if (pdfData.status === "error") {
                    setBookError(pdfData?.message);
                }
            } catch (error: any) {
                console.error(`Failed to fetch source info `, error);
                setBookError(error.message); // Set error message when request fails
            } finally {
                setIsLoading(false);
            }
        }
    }
    useEffect(() => {
        if (citation.media_type == "podcast" || citation.media_type == "sps_podcast") fetchPodcastInfo(citation);
        else if (citation.media_type == "books") fetchBookInfo(citation);
        else fetchSeedsInfo(!citation.file_name ? citation.id : citation.file_name);
    }, []);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }

        // Cleanup on unmount
        return () => {
            document.body.style.overflow = "";
        };
    }, [open]);
    return (
        <div className="card_bg_color card_text_color  overflow-y-auto">
            <Drawer
                open={open}
                onClose={onClose}
                direction="right"
                size={size}
                duration={1000}
                className="card_bg_color card_text_color border-2 border-solid border-gray-400"
                // lockBackgroundScroll={open}
            >
                {citation.media_type === "podcast" || citation.media_type === "sps_podcast" ? (
                    <PodcastViewerInDrawer citation={citation} podcastText={podcastText} podcastError={podcastError} onClose={onClose} />
                ) : citation.media_type === "books" ? (
                    <BookViewerInDrawer
                        citation={citation}
                        pageImages={pdfBookImages}
                        bookLink={bookLink}
                        bookError={bookError}
                        onClose={onClose}
                        isLoading={isLoading}
                    ></BookViewerInDrawer>
                ) : (
                    <ExclusiveContentViewer
                        seedFileData={seedFileData}
                        isLoading={isLoading}
                        error={error}
                        onClose={onClose}
                        formatDate={formatDate}
                    ></ExclusiveContentViewer>
                    // <div>exclusive content</div>
                )}
            </Drawer>
        </div>
    );
};
export default ShowCitationExplorerSource;
